import { render, staticRenderFns } from "./DashEducation.vue?vue&type=template&id=24ae1b03&scoped=true&"
import script from "./DashEducation.vue?vue&type=script&lang=js&"
export * from "./DashEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae1b03",
  null
  
)

export default component.exports